/* @flow */
import {
  GET_SCENES,
  GET_SCENES_SUCCESS,
  GET_SCENES_FAILURE,
  SET_VIEW_SCENE,
  SEARCH_SCENE,
} from '../../configs/constants'
import InitialState from './initialState'

const initialState = new InitialState()

export default function commonReducer(state = initialState, action) {
  if (!(state instanceof InitialState)) return initialState.merge(state)
  
  switch (action.type) {
    case GET_SCENES:
      return state.set('isLoading', true)
    case GET_SCENES_SUCCESS:
      return state.set('locations', action.locations)
                  .set('isLoading', false)
    case GET_SCENES_FAILURE:
      return state.set('scenes', { error: action.error })
                  .set('isLoading', false)
    case SET_VIEW_SCENE:
      return state.set('filtered', action.scenes)
    case SEARCH_SCENE:
      return state.set('filtered', state.locations.filter( (location) => location.name === action.payload.keyword ))
    default:
      return state
  }
}


// WEBPACK FOOTER //
// ./src/reducers/scene/index.js